// acciones
export const SAGA_GET_USUARIO_BY_ID = 'usuariosReducer/SAGA_GET_USUARIO_BY_ID'
export const SAVE_USUARIO = 'usuariosReducer/SAVE_USUARIO'
export const SAGA_SAVE_USUARIO = 'usuariosReducer/SAGA_SAVE_USUARIO'
export const SAGA_REESTABLECER_CONTRASENIA = 'usuariosReducer/SAGA_REESTABLECER_CONTRASENIA'
export const SAGA_REACTIVAR_USUARIO = 'usuariosReducer/SET_REACTIVAR_USUARIO'
export const SAGA_ELIMINAR_USUARIO = 'usuariosReducer/SAGA_ELIMINAR_USUARIO'
export const SAGA_MAIL_CONFIRMAR_USUARIO = 'usuariosReducer/SAGA_MAIL_CONFIRMAR_USUARIO'
export const SAGA_CONFIRMAR_USUARIO = 'usuariosReducer/SAGA_CONFIRMAR_USUARIO'

/**------------------- */
export const SAGA_GET_NUEVOS_USUARIOS = 'usuariosReducer/SAGA_GET_NUEVOS_USUARIOS'
export const SET_NUEVOS_USUARIOS = 'usuariosReducer/SET_NUEVOS_USUARIOS'

export const SAGA_GET_USUARIOS = 'usuariosReducer/SAGA_GET_USUARIOS'
export const SET_USUARIOS = 'usuariosReducer/SET_USUARIOS'

export const SAGA_HABILITAR = 'usuarioReducer/SAGA_HABILITAR'
export const SET_USUARIO_HABILITADO = 'usuarioReducer/SET_USUARIO_HABILITADO'

/**------------ */
export const SAGA_GET_LOCALIDADES = "usuarioReducer/SAGA_GET_LOCALIDADES"
export const SAVE_LOCALIDADES = "usuarioReducer/SAVE_LOCALIDADES"

export const SAGA_SAVE_DIRECCION_ENTREGA = 'sessionReducer/SAGA_SAVE_DIRECCION_ENTREGA'

/**-------------- */
export const SAGA_AGREGAR_LISTABLANCA = 'usuarioReducer/SAGA_AGREGAR_LISTABLANCA'
export const SAGA_AGREGAR_LISTANEGRA = 'usuarioReducer/SAGA_AGREGAR_LISTANEGRA'
export const SAGA_ELIMINAR_LISTABLANCA = 'usuarioReducer/SAGA_ELIMINAR_LISTABLANCA'
export const SAGA_ELIMINAR_LISTANEGRA = 'usuarioReducer/SAGA_ELIMINAR_LISTANEGRA'

// funciones


export const sagaSaveDireccionEntrega = (payload) => ({
    type: SAGA_SAVE_DIRECCION_ENTREGA,
    payload
})

export const sagaGetNuevosUsuarios = (page) =>({
    type: SAGA_GET_NUEVOS_USUARIOS,
    payload: {
        page: page || 1
    }
})

export const setUsuarios = (payload) =>({
    type: SET_USUARIOS,
    payload
})

export const sagaGetUsuarios = (nombre, nombre_apellido, razon_social, tipoUsuario, estado, localidad, noHabilitados, noConfirmados, page, pageSize) =>({
    type: SAGA_GET_USUARIOS,
    payload: {
        nombre,
        nombre_apellido,
        razon_social,
        tipoUsuario,
        estado,
        localidad, 
        noHabilitados,
        noConfirmados,
        page: page || 1,
        pageSize: pageSize || 8,
    }
})

export const setNuevosUsuarios = (payload) =>({
    type: SET_NUEVOS_USUARIOS,
    payload
})


export const sagaHabilitarUsuario = (id, page) =>({
    type: SAGA_HABILITAR,
    payload: {id},
    page
})
export const sagaEliminarUsuario = (id) =>({
    type: SAGA_ELIMINAR_USUARIO,
    payload: {id}
})

export const sagaMailConfirmarUsuario = (id) =>({
    type: SAGA_MAIL_CONFIRMAR_USUARIO,
    payload: {id}
})
export const sagaConfirmarUsuario = (id) =>({
    type: SAGA_CONFIRMAR_USUARIO,
    payload: {id}
})
export const sagaReestablecerUsuario = (id) =>({
    type: SAGA_REESTABLECER_CONTRASENIA,
    payload: {id}
})
export const sagaReactivarUsuario = (id) =>({
    type: SAGA_REACTIVAR_USUARIO,
    payload: {id}
})

export const setUsuarioHabilitado = (success, id) =>({
    type: SET_USUARIO_HABILITADO,
    success,
    id
})

export const sagaGetUsuarioById = (id) =>({
    type: SAGA_GET_USUARIO_BY_ID,
    payload: {id}
})

export const saveUsuario = (payload) =>({
    type: SAVE_USUARIO,
    payload: payload
})

export const sagaSaveUsuario = (user, history) =>({
    type: SAGA_SAVE_USUARIO,
    payload: user,
    history
})

export const sagaGetLocalidades = (nombre) =>({
    type: SAGA_GET_LOCALIDADES,
    nombre
})

export const saveLocalidades = (payload) =>({
    type: SAVE_LOCALIDADES,
    payload
})

export const sagaAgregarListaBlanca = (id) =>({
    type: SAGA_AGREGAR_LISTABLANCA,
    payload: {id},
})

export const sagaEliminarListaBlanca = (id) =>({
    type: SAGA_ELIMINAR_LISTABLANCA,
    payload: {id}
})

export const sagaAgregarListaNegra = (id) =>({
    type: SAGA_AGREGAR_LISTANEGRA,
    payload: {id}
})

export const sagaEliminarListaNegra = (id) =>({
    type: SAGA_ELIMINAR_LISTANEGRA,
    payload: {id}
})
